import './MapButton.css';
import locationIcon from './../../images/location.svg';
import refreshIcon from './../../images/refresh.svg';
const MapButton = ({ handleRefreshClick, loadingEvents }) => {
    return (
        <div className='map__button'>
            <div className='map__button_item'>
                <button onClick={loadingEvents}>
                    <img src={refreshIcon} alt='refresh' />
                </button>
            </div>
            <div className='map__button_item'>
                <button onClick={handleRefreshClick}>
                    <img src={locationIcon} alt='refresh' />
                </button>
            </div>
        </div>
    );
};

export default MapButton;
